import { useMutation } from '@tanstack/react-query';

import { Illuminate } from '@graylog/enterprise-api';

const enableBundles = async ({ processing_pack_ids = [], spotlight_pack_ids = [], shareRequest = null }) =>
  Illuminate.enableCurrentPacks({ entity: { processing_pack_ids, spotlight_pack_ids }, share_request: shareRequest });

const useSetupIlluminate = () => {
  const enableBundlesMutation = useMutation({
    mutationFn: enableBundles,
    retry: false,
  });

  return {
    enableBundlesMutation,
  };
};

export default useSetupIlluminate;
